export default __webpack_public_path__ + "static/media/V Srinivasan.46d9e97d.jpg";